/**
 * File: card.js.
 *
 * Handles card function
 */

const $ = require('jquery');

export default {
  element: $('.js-moa-card'),
  init() {
    if (this.element) {
      this.render();
    }
  },
  render() {
    const details = $('.js-moa-card-details');
    const arr = [];
    [ ...details ].forEach((item) => {
      const offsetTop = parseInt($(item).offset().top);
      if (typeof(arr[offsetTop]) == "undefined") {
        arr[offsetTop] = {items: [], heights: []};
      }
      arr[offsetTop]["items"].push(item);
      arr[offsetTop]["heights"].push(item.clientHeight);
    });

    arr.forEach(row => {
      const max = Math.max(...row.heights);
      row.items.forEach(item => {
        item.style.height = `${ max }px`;
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
